export enum InputType {
  INPUT = 'input',
  REMOTE_AUTOCOMPLETE = 'remoteAutocomplete'
}

type Column = {
  type: InputType;
  name: string;
  label: string;
  url?: string;
  filter?: string;
};

export const columnsDefinition: Column[] = [
  { type: InputType.INPUT, name: 'registrationNumber', label: 'Registrační značka' },
  { type: InputType.INPUT, name: 'vinNumber', label: 'VIN' },
  { type: InputType.INPUT, name: 'registrationCertificate', label: 'Osvědčení o registraci vozidla' },
  { type: InputType.INPUT, name: 'type', label: 'Druh' },
  { type: InputType.INPUT, name: 'brand', label: 'Značka', url: '/metropolis/api/wv/brands' },
  { type: InputType.INPUT, name: 'model', label: 'Model' },
  { type: InputType.INPUT, name: 'color', label: 'Barva', url: '/metropolis/api/wv/colors' },
  { type: InputType.INPUT, name: 'operationalWeight', label: 'Provozní hmotnost' },
  { type: InputType.INPUT, name: 'totalWeight', label: 'Celková hmotnost' }
];



// WEBPACK FOOTER //
// ./src/components/vehicle/columns.ts